import React from 'react';
import RCLMeterIntroduction from '../../../home/components/RCLMeterIntroduction';
import UtilizationHorseshoe from '../../../shared/components/misc/UtilizationHorseshoe';
import Formatters from '../../../../features/shared/utils/Formatters'
import creditLineValidator, { isExpired } from '../../../../utils/creditLineValidator';
import { isEmpty } from 'lodash';
import moment from 'moment';

export default class CreditLine extends React.Component {
  get isButtonDisabled() {
    const {
      credit_remaining = 0.0,
      active_rcl_offers_amount_total = 0.0,
    } = this.props.creditLimit;
    const {
      convenience_fee_type,
      option_terms_rate,
      post_cutoff_live_date,
      pre_cutoff_live_date,
      end_timestamp,
      start_timestamp,
    } = this.props.creditLine;
    const validCreditLine = creditLineValidator({
      convenience_fee_type,
      option_terms_rate,
      post_cutoff_live_date,
      pre_cutoff_live_date,
      end_timestamp,
      start_timestamp,
    });
    return (
      credit_remaining - active_rcl_offers_amount_total < 1 ||
      !validCreditLine 
    );
  }

  onClickHandler = (_e) => {
    const { onClickActionHandler, actionPath } = this.props
    if (onClickActionHandler && actionPath) {
      onClickActionHandler(actionPath)
    }
  }

  onClickPayWithCreditLine = (_e) => {
    window.location = this.payWithCreditLineUrl;
  }

  get payWithCreditLineUrl() {
    const { leadId } = this.props;
    return `${process.env.REACT_APP_FC_CONNECT_BASE_URL}/leads/${leadId}/home`
  }

  get isExpired() {
    const { end_timestamp } = this.props.creditLine;
    return isExpired(end_timestamp);
  }

  get heading() {
    if (this.isExpired) { return 'Your credit line has expired.'; }

    return 'You can loan up to';
  }

  get utilizationProps() {
    let {
      credit_remaining = 0.0,
      max_potential_credit_limit = 0.0,
      active_rcl_offers_amount_total = 0.0,
    } = this.props.creditLimit;

    if (this.isExpired) {
      credit_remaining = max_potential_credit_limit
      active_rcl_offers_amount_total = 0 
    }

    return {
      availableAmount: parseFloat(credit_remaining.toFixed(2)),
      maxAmount: parseFloat(max_potential_credit_limit.toFixed(2)),
      pendingAmount: parseFloat(active_rcl_offers_amount_total.toFixed(2)),
      showUtilization: !this.isExpired,
    }
  }

  renderAvailabilitySection = () => {
    if (this.isExpired) { return null; }

    const { end_timestamp } = this.props.creditLine;
    const end_date = moment.utc(end_timestamp).toISOString();
    return (
      <section className='cardSection -primary _textAlign_center'>
        <p data-testid='expiration-date-copy' className='_marginBottom--small'>
          This credit line is available until {Formatters.longDate(end_date)}
        </p>
        <a
          className='ds-btn _link -base _textUnderline'
          data-testid='terms-and-condition-link'
          href='https://www.firstcircle.ph/terms-and-conditions'
          style={{ color: '#676767', fontSize: '0.95em' }}
          target='_blank'
          rel='noopener noreferrer'
        >
          Terms and Conditions
        </a>
      </section>
    );
  }

  get shouldDisplayPayWithCreditLine() {
    if (isEmpty(this.props.fcLead)) { return false }
    const { id, supplier_payments_enabled_at } = this.props.fcLead;

    return id && supplier_payments_enabled_at;
  }

  render() {
    const {
      creditLine = {},
      actionPath = null,
    } = this.props;
    const { id } = creditLine;

    if (!id) {
      return (
        <RCLMeterIntroduction
          redirectTo={this.props.onClickActionHandler}
          url={'/apply-now'}
        />
      )
    }

    return (
      <div className='ds-card' data-testid="credit-line-card">
        <section className='cardSection _paddingTop--none'>
          <UtilizationHorseshoe
            containerClassName="_displayBlock _margin--auto _marginBottom--xsmall"
            headingText={this.heading}
            isExpired={this.isExpired}
            {...this.utilizationProps}
          />
          <div className="_displayFlex _justifyContent-center">
            { !this.isExpired && (
              <button
                data-testid="take-out-a-loan"
                data-path={actionPath}
                className="ds-btn -primary"
                onClick={this.onClickHandler}
                disabled={this.isButtonDisabled}
              >
                Take out a loan
              </button>
            ) }
            { !this.isExpired && this.shouldDisplayPayWithCreditLine && (
              <button
                data-testid="pay-with-credit-line-button"
                className="ds-btn -primary _marginLeft--small"
                onClick={this.onClickPayWithCreditLine}
                data-path={this.payWithCreditLineUrl}
                disabled={this.isButtonDisabled}
              >
                Pay with Credit Line
              </button>
            ) }
          </div>
        </section>
        { this.renderAvailabilitySection() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/CreditLimit/components/utilization/CreditLine.js